<template>
  <DataTable
    :value="coefficients"
    class="scroll-table-y main-table scrollbar-custom"
    stripedRows
    :loading="isLoading"
    dataKey="level"
  >
    <Column field="level" header="Уровень категории" style="min-width: 200px">
      <template #body="slotProps">
        {{ getLevelName(slotProps.data.level) }}
      </template>
    </Column>
    <Column field="cost" header="Коэффициент" style="min-width: 200px">
      <template #body="slotProps">
        <InputNumber
          v-model="slotProps.data.cost"
          :disabled="isDenied"
          mode="decimal"
          :min="0"
          :maxFractionDigits="2"
          :useGrouping="false"
          @update:modelValue="onCostChange(slotProps.data)"
          class="coefficient-input"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAuthStore } from "@/store/auth/login";
import { CategoryCost } from "@/store/expenses/category_costs";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";

const props = defineProps<{
  coefficients: CategoryCost[];
  isLoading: boolean;
}>();

const emit = defineEmits(["updateCoefficient"]);

const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["expenses:edit"]);
});

const getLevelName = (level: string) => {
  return `Уровень ${level.toUpperCase()}`;
};

const onCostChange = (item: CategoryCost) => {
  emit("updateCoefficient", item);
};
</script>

<style lang="scss" scoped>
.coefficient-input {
  width: 100%;
  max-width: 200px;

  :deep(.p-inputnumber-input) {
    width: 100%;
  }
}
</style>
